var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css, styled } from 'styled-components';
export default styled.li.withConfig({
  displayName: "styled",
  componentId: "1_5_0__sc-11ab7hb-0"
})(["", "{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n      list-style-type: none;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    "])), theme.vars.spacing_03);
});